// MUI
import { Box, Container } from '@mui/material';

// Components
import { RegisterForm, RegisterHeader } from './components';

const RegisterPage = () => {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#0E1720',
        px: { xs: 2, sm: 3 },
        '&:before': {
          content: '""',
          position: 'absolute',
          inset: 0,
          background: `
            radial-gradient(800px 500px at 20% 10%, rgba(0,224,255,0.08), transparent 60%),
            radial-gradient(700px 500px at 90% 90%, rgba(29,176,191,0.10), transparent 60%)
          `,
          pointerEvents: 'none',
        },
      }}
    >
      <Container
        maxWidth="sm"
        sx={{ position: 'relative', zIndex: 1 }}
      >
        <RegisterHeader />
        <RegisterForm />
      </Container>
    </Box>
  );
};

export default RegisterPage;
